'use client';

// TODO: When we add content to this component, make it non-internal
/**
 * @ignore - internal component.
 */
function ToolbarActions() {
  return null;
}
export { ToolbarActions };